// signin_email_error / signup_email_error `error_type`. The backend answers every
// failed sign-in with the same 401. The parabo-web form then asks check-email, so
// there an unknown account is UNKNOWN_EMAIL and a wrong password stays INVALID_CREDENTIALS.
export const AUTH_ERROR_TYPE = Object.freeze({
  MISSING_FIELDS: 'missing_fields',
  INVALID_EMAIL: 'invalid_email',
  INVALID_PASSWORD: 'invalid_password',
  INVALID_CREDENTIALS: 'invalid_credentials',
  UNKNOWN_EMAIL: 'unknown_email',
  EMAIL_TAKEN: 'email_taken',
  SIGNUP_REJECTED: 'signup_rejected',
  NETWORK_ERROR: 'network_error',
  SERVER_ERROR: 'server_error',
});

// Where the email form was shown. withAuth renders it in place of the protected
// page, so the route says where the user hit the sign-in wall.
export const AUTH_CONTEXT = Object.freeze({
  SIGNIN: 'signin',
  CART: 'cart',
  CHECKOUT: 'checkout',
  EDITOR: 'editor',
  ACCOUNT: 'account',
  OTHER: 'other',
});

/**
 * @param {{ code: number, reason?: string, isNetworkError?: boolean }} error authApi signIn / signUp error
 */
export const authErrorType = error => {
  if (error.isNetworkError) return AUTH_ERROR_TYPE.NETWORK_ERROR;
  if (error.code === 401) return AUTH_ERROR_TYPE.INVALID_CREDENTIALS;
  if (error.reason === 'email_taken') return AUTH_ERROR_TYPE.EMAIL_TAKEN;
  // Sign-up answers 400 for an invalid email and a short password alike.
  if (error.code === 400) return AUTH_ERROR_TYPE.SIGNUP_REJECTED;
  return AUTH_ERROR_TYPE.SERVER_ERROR;
};

/**
 * @param {string} pathname Next.js route pattern (router.pathname)
 */
export const authContext = pathname => {
  if (pathname === '/signin') return AUTH_CONTEXT.SIGNIN;
  if (pathname === '/cart') return AUTH_CONTEXT.CART;
  if (pathname.startsWith('/cart/')) return AUTH_CONTEXT.CHECKOUT;
  if (pathname.startsWith('/editor')) return AUTH_CONTEXT.EDITOR;
  if (pathname.startsWith('/user')) return AUTH_CONTEXT.ACCOUNT;
  return AUTH_CONTEXT.OTHER;
};
